import React, { useState } from "react";
import { motion } from "framer-motion";
import { Inline } from "../Inline";

const OPTIONS = [
  { k: "lake", phrase: "\"data lake\" / the default", a: "**S3** — the infinite object warehouse. When nothing else in the stem forces a special store, S3 is the answer." },
  { k: "ebs", phrase: "\"attach a volume to one instance\"", a: "**EBS** — one machine's personal hard drive. Single-instance, block storage." },
  { k: "efs", phrase: "\"NFS,\" \"shared,\" \"hybrid,\" \"file locking\"", a: "**EFS** — Everyone's Folder. Many machines mount it at once, it speaks NFS, and it reaches on-premises." },
  { k: "lustre", phrase: "\"millions of files,\" fast distributed training", a: "**FSx for Lustre** — the GPU racetrack. Ultra-fast, and it can LINK to an S3 bucket (lazy-loads, no copy)." },
  { k: "glacier", phrase: "\"archive after 30 days\"", a: "**Glacier** — the cheap deep-freeze, reached via an S3 lifecycle policy." },
];

export function StoragePicker() {
  const [active, setActive] = useState(null);
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="my-12 border-2 border-[#2F6F4F] bg-white/70 backdrop-blur-sm p-7 md:p-9"
      data-testid="widget-storage-picker"
    >
      <div className="font-mono-ui text-[10px] font-bold uppercase tracking-[0.22em] text-[#2F6F4F] mb-2">
        Try it · Match the phrase to the storage service
      </div>
      <p className="text-[13px] text-[#1C2430]/55 mb-5">Click a trigger phrase to see which service it points to.</p>
      <div className="flex flex-wrap gap-2 mb-4">
        {OPTIONS.map((o) => (
          <button
            key={o.k}
            onClick={() => setActive(o.k)}
            data-testid={`storage-option-${o.k}`}
            className={`font-mono-ui text-[12px] px-3 py-2 border transition-colors duration-200 ${
              active === o.k ? "bg-[#1C2430] text-[#FBFBF9] border-[#1C2430]" : "bg-white border-[var(--border-heavy)] hover:bg-black/[0.03]"
            }`}
          >
            {o.phrase}
          </button>
        ))}
      </div>
      <div className="bg-black/[0.03] px-4 py-3 text-[13.5px] leading-relaxed text-[#1C2430]/85 min-h-[48px]" data-testid="storage-output">
        {active ? <Inline text={OPTIONS.find((o) => o.k === active).a} /> : "Pick a phrase above to reveal the answer."}
      </div>
    </motion.div>
  );
}
